import { useForm } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { useAddPaymentRequestsMutation } from 'modules/banking/hooks/useAddPaymentRequests'

export interface AddPaymentRequestsFormValues {
  paymentId: number
  paymentRequestIds: number[]
}

export const useAddPaymentRequestsForm = ({
  onSuccess,
  paymentRequestIds,
}: {
  onSuccess: () => void
  paymentRequestIds: number[]
}) => {
  const { submitAddPaymentRequests, loading } = useAddPaymentRequestsMutation()

  const form = useForm<AddPaymentRequestsFormValues>({
    defaultValues: {
      paymentId: -1,
      paymentRequestIds: paymentRequestIds,
    },
    validateOnChange: false,
    validate: (values) => {
      const errors: Record<string, string> = {}

      if (values.paymentId === -1) {
        errors.paymentId = i18n.t('banking.bulk_payment.forms.validation_mandatory')
      }

      return errors
    },
    onSubmit: async (values) => {
      return await submitAddPaymentRequests({
        paymentRequestIds: values.paymentRequestIds,
        paymentId: values.paymentId,
        onSuccess: onSuccess,
      })
    },
  })

  return {
    form,
    loading,
  }
}
